export default "__VITE_ASSET__d9c410bd__"